import { TypographyProps } from '@reapit/elements'
import { RenderHTML, CardAction, IFormContent } from '@reapitform/common-ui'
import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

export interface IRenderFormContentProps {
  StringContainer: React.ElementType<TypographyProps>
  content: IFormContent
  cardId: string
  index: number
}

export const RenderFormContent: React.FC<IRenderFormContentProps> = ({ StringContainer, content, cardId, index }) => {
  const queryClient = useQueryClient()

  if (content.isHtml) return <RenderHTML htmlString={content.data as string} />
  if (content.isAction)
    return (
      <CardAction
        index={index}
        action={content.actionType}
        data={content.data}
        queryClient={queryClient}
        cardId={cardId}
      />
    )

  if (typeof content.data !== 'string') return null
  return <StringContainer>{content.data as string}</StringContainer>
}
